import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Button,
  Box,
  Card,
  CardContent,
  CardMedia,
  Link,
  Typography,
} from "@material-ui/core";
import useStyles from "./style";
import ProductCard from "../../../Cards/ProductCard.jsx";
import GiftCard from "../../../Cards/GiftCard.jsx";
import photo1 from "../../../../assets/card1.png";
import photo2 from "../../../../assets/card2.png";
import photo3 from "../../../../assets/card3.png";
import photo4 from "../../../../assets/card4.png";

const productCard = {
  img: photo1,
  title: "Purple Grape",
  sizes: "!0x10x10",
  colors: "lrojo, azul, negro",
  smell: "Floral",
  code: "090291309",
};
const giftCards = [
  {
    img: photo2,
    title: "Something extra",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
  },
  {
    img: photo3,
    title: "On the go",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
  },
  {
    img: photo4,
    title: "Best mom",
    description:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
  },
];

const ThirdSection = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.thirdSection}>
      <Box component="div" className={classes.backgroundOne}>
        <Typography variant="h4" className={classes.title1}>
          LAS MÁS VENDIDAS
        </Typography>
        <div className={classes.spacer}></div>
        <Typography variant="h4" className={classes.title2}>
          GIFT SETS
        </Typography>
      </Box>
      <Box component="div" className={classes.backgroundTwo}>
        <Box component="div" className={classes.img1} />
      </Box>
      <Box component="div" className={classes.cards}>
        <Box component="div" className={classes.productCard}>
          <ProductCard info={productCard} />
        </Box>
        <Box component="div" className={classes.giftCard1}>
          <GiftCard info={giftCards[0]} />
        </Box>
        <Box component="div" className={classes.giftCard2}>
          <GiftCard info={giftCards[1]} />
        </Box>
        <Box component="div" className={classes.giftCard3}>
          <GiftCard info={giftCards[2]} />
        </Box>
        <Link Link component={RouterLink} to="#" className={classes.moreInfo}>
          <Button className={classes.btn} variant="contained" color="primary">
            Ver más
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default ThirdSection;
